import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import styled from 'styled-components'



class G30n extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({height: window.innerHeight})
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({width: window.innerWidth})
        }
    }

    
    componentDidMount() {
        this.setState({height: window.innerHeight, width: window.innerWidth})
        window.addEventListener('resize', this.updateDimensions)
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {

        const Section = styled.section`
            position: relative;
            padding-top: 50px;
            background-color: #111;            
        `

        const Text = styled.p`
            font-size: 40px;
            font-weight: 300;
            color: rgb(197, 197, 197);
            padding-bottom: 30px;
            line-height: 70px;
            font-style: italic;
        `

        const AboutContainer = styled(Container)`
            padding: 50px 0;
            @media (max-width: 500px) {
                padding: 50px 20px;
            }
        `
              
        
        return (
                <Section>
                    <AboutContainer>
                    <Row>                        
                        <Col md={12}>
                            
                                <Text>
                                "Los correos electrónicos no protegidos equivalen a enviar una postal normal escrita a lápiz,
                                 ya que terceros pueden interceptar información confidencial o modificar el contenido."</Text>                                
                            
                        </Col>
                    </Row>
                    </AboutContainer>                    
                </Section>
            
        )
    }
}

export default G30n